// import { yupResolver } from '@hookform/resolvers/yup';
// import CloseIcon from '@mui/icons-material/Close';
// import {
//   Alert,
//   Autocomplete,
//   Avatar,
//   Box,
//   Button,
//   CircularProgress,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { AppDispatch, RootState } from 'app/store';
// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import {
//   FaCalendarAlt,
//   FaCamera,
//   FaCheckCircle,
//   FaEnvelope,
//   FaFileAlt,
//   FaPhone,
//   FaTools,
//   FaUndo,
//   FaUser
// } from 'react-icons/fa';
// import { FiArrowLeft } from 'react-icons/fi';
// import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { fetchParticipantsList } from 'slices/HomeTilesSlices';
// import {
//   clearMaintenanceRequestState,
//   MaintenanceRequest,
//   MaintenanceRequestFormData,
//   submitMaintenanceRequest
// } from 'slices/NdisSlices/reportAllForms/maintenanceRequestSlice';
// import * as yup from 'yup';

// // Validation schemas
// const generalSchema = yup
//   .object({
//     id: yup.string().optional(),
//     name: yup.string().required('Name is required'),
//     role: yup.string().optional().default(''),
//     phone_number: yup.string().optional().default(''),
//     email_address: yup.string().email('Invalid email address').optional().default(''),
//     date_of_request: yup.string().required('Date of request is required'),
//     location_of_issue: yup.string().required('Location of issue is required'),
//     other_location: yup.string().when('location_of_issue', {
//       is: 'Other',
//       then: (schema) => schema.required('Please specify other location'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     description_of_issue: yup.string().required('Description of issue is required'),
//     urgency_level: yup.string().required('Urgency level is required'),
//     date_issue_noticed: yup.string().required('Date issue was first noticed is required'),
//     issue_reported_before: yup.string().required('Please specify if issue was reported before'),
//     previous_report_date: yup.string().when('issue_reported_before', {
//       is: 'Yes',
//       then: (schema) => schema.required('Previous report date is required'),
//       otherwise: (schema) => schema.optional().default('')
//     }),
//     preferred_access_time: yup.string().required('Preferred access time is required'),
//     access_instructions: yup.string().optional().default(''),
//     participant_aware: yup.string().required('Please specify if participant is aware'),
//     photo: yup.mixed<File | string>().optional().default(undefined),
//     received_by: yup.string().optional().default(''),
//     date_received: yup.string().optional().default(''),
//     action_taken: yup.string().optional().default(''),
//     assigned_to: yup.string().optional().default(''),
//     completion_date: yup.string().optional().default(''),
//     notes: yup.string().optional().default(''),
//     client_email: yup.string().optional().default(''),
//     group_id: yup.string().optional().default(''),
//     service_name_id: yup.string().optional().default('')
//   })
//   .required() as yup.ObjectSchema<MaintenanceRequestFormData>;

// const officeSchema = yup
//   .object({
//     id: yup.string().optional(),
//     name: yup.string().optional().default(''),
//     role: yup.string().optional().default(''),
//     phone_number: yup.string().optional().default(''),
//     email_address: yup.string().email('Invalid email address').optional().default(''),
//     date_of_request: yup.string().optional().default(''),
//     location_of_issue: yup.string().optional().default(''),
//     other_location: yup.string().optional().default(''),
//     description_of_issue: yup.string().optional().default(''),
//     urgency_level: yup.string().optional().default(''),
//     date_issue_noticed: yup.string().optional().default(''),
//     issue_reported_before: yup.string().optional().default(''),
//     previous_report_date: yup.string().optional().default(''),
//     preferred_access_time: yup.string().optional().default(''),
//     access_instructions: yup.string().optional().default(''),
//     participant_aware: yup.string().optional().default(''),
//     photo: yup.mixed<File | string>().optional().default(undefined),
//     received_by: yup.string().optional().default(''),
//     date_received: yup.string().optional().default(''),
//     action_taken: yup.string().optional().default(''),
//     assigned_to: yup.string().optional().default(''),
//     completion_date: yup.string().optional().default(''),
//     notes: yup.string().optional().default(''),
//     client_email: yup.string().optional().default(''),
//     group_id: yup.string().optional().default(''),
//     service_name_id: yup.string().optional().default('')
//   })
//   .required() as yup.ObjectSchema<MaintenanceRequestFormData>;

// interface MaintenanceRequestFormProps {
//   initialData?: MaintenanceRequest;
//   onClose?: () => void;
// }

// const MaintenanceRequestForm: React.FC<MaintenanceRequestFormProps> = ({
//   initialData,
//   onClose
// }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
//   const dispatch = useDispatch<AppDispatch>();
//   const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
//   const { message, loading, error } = useTypedSelector((state) => state.maintenanceRequest);
//   const [previewImage, setPreviewImage] = useState<string | null>(initialData?.photo || null);
//   const [alreadyFilled, setAlreadyFilled] = useState(false);
//   const [isClientsLoading, setIsClientsLoading] = useState(false);
//   const [clientsError, setClientsError] = useState<string | null>(null);
//   const fileInputRef = useRef<HTMLInputElement>(null);
//   const navigate = useNavigate();
//   const location = useLocation();
//   const { pathname } = useLocation();

//   // Local storage data
//   const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//     label?: string;
//     id?: number;
//     email?: string;
//     projectId?: string;
//     serviceId?: string;
//   };
//   const loginInfo = localStorage.getItem('user-details');
//   const userDetails = loginInfo ? JSON.parse(loginInfo) : null;

//   // Redux state data
//   const selectedProjectId = useTypedSelector(
//     (state: RootState) => state.homeTilesServices.selectedProjectId
//   );
//   const selectedServiceTitle = useTypedSelector(
//     (state: RootState) => state.serviceSelected.selectedServiceTitle
//   );
//   const email = userDetails?.email || '';
//   const role = userDetails?.role ? [userDetails.role] : [''];

//   // Participants list
//   const participantsList = useTypedSelector(
//     (state: RootState) => state?.homeTilesServices?.participants
//   ) || { participants_list: [] };

//   // Prepare clients list
//   const clientsList = useMemo(
//     () =>
//       participantsList.participants_list?.map(
//         (participant: { name: string; email: string }, index: number) => ({
//           label: participant.name || `Client ${index + 1}`,
//           id: index + 1,
//           email: participant.email
//         })
//       ) || [],
//     [participantsList.participants_list]
//   );

//   // Fetch participants
//   useEffect(() => {
//     if (selectedProjectId && selectedServiceTitle && email && role.length > 0) {
//       setIsClientsLoading(true);
//       dispatch(
//         fetchParticipantsList({
//           group_id: selectedProjectId || '',
//           service_name_id: selectedServiceTitle || '',
//           nested_component_id: pathname,
//           email: email,
//           roles: role,
//           client_name: ''
//         })
//       )
//         .unwrap()
//         .then(() => {
//           setIsClientsLoading(false);
//         })
//         .catch((error) => {
//           setIsClientsLoading(false);
//           setClientsError('Failed to load clients. Please try again later.');
//         });
//     } else {
//       setIsClientsLoading(false);
//     }
//   }, [selectedProjectId]);

//   const searchParams = new URLSearchParams(location.search);
//   const tabParam = searchParams.get('tab') || 'feedbacks';
//   const maintenanceId = initialData?.id || undefined;

//   // Determine which form section to show based on route
//   const isGeneralRoute = location.pathname === '/maintenance';
//   const isOfficeRoute =
//     location.pathname === '/ndis-operations/corporate-services' && tabParam === 'feedbacks';

//   // Check if Office Use Only form is already filled
//   useEffect(() => {
//     if (isOfficeRoute && initialData) {
//       const isFilled = [
//         initialData.received_by,
//         initialData.date_received,
//         initialData.action_taken,
//         initialData.assigned_to,
//         initialData.completion_date,
//         initialData.notes
//       ].some((field) => field && field.trim() !== '');
//       setAlreadyFilled(isFilled);
//     } else {
//       setAlreadyFilled(false);
//     }
//   }, [initialData, isOfficeRoute]);

//   // Current datetime as default
//   const defaultDateTime = new Date().toISOString().split('T')[0];

//   // Use separate useForm hooks for each route
//   const generalForm = useForm<MaintenanceRequestFormData>({
//     resolver: yupResolver<MaintenanceRequestFormData>(generalSchema),
//     defaultValues: {
//       id: initialData?.id || '',
//       name: initialData?.name || selectedClient?.label || userDetails?.name || '',
//       role: initialData?.role || '',
//       phone_number: initialData?.phone_number || '',
//       email_address:
//         initialData?.email_address || selectedClient?.email || userDetails?.email || '',
//       date_of_request: initialData?.date_of_request || defaultDateTime,
//       location_of_issue: initialData?.location_of_issue || '',
//       other_location: initialData?.other_location || '',
//       description_of_issue: initialData?.description || '',
//       urgency_level: initialData?.urgency_level || '',
//       date_issue_noticed: initialData?.date_issue_noticed || defaultDateTime,
//       issue_reported_before: initialData?.issue_reported_before || '',
//       previous_report_date: initialData?.previous_report_date || '',
//       preferred_access_time: initialData?.preferred_access_time || '',
//       access_instructions: initialData?.access_instructions || '',
//       participant_aware: initialData?.participant_aware || '',
//       photo: undefined,
//       received_by: '',
//       date_received: '',
//       action_taken: '',
//       assigned_to: '',
//       completion_date: '',
//       notes: '',
//       client_email: selectedClient?.email || '',
//       group_id: selectedProjectId || selectedClient?.projectId || '',
//       service_name_id: selectedServiceTitle || selectedClient?.serviceId || ''
//     }
//   });

//   const officeForm = useForm<MaintenanceRequestFormData>({
//     resolver: yupResolver<MaintenanceRequestFormData>(officeSchema),
//     defaultValues: {
//       id: initialData?.id || '',
//       name: initialData?.name || selectedClient?.label || userDetails?.name || '',
//       role: initialData?.role || '',
//       phone_number: initialData?.phone_number || '',
//       email_address:
//         initialData?.email_address || selectedClient?.email || userDetails?.email || '',
//       date_of_request: initialData?.date_of_request || defaultDateTime,
//       location_of_issue: initialData?.location_of_issue || '',
//       other_location: initialData?.other_location || '',
//       description_of_issue: initialData?.description || '',
//       urgency_level: initialData?.urgency_level || '',
//       date_issue_noticed: initialData?.date_issue_noticed || defaultDateTime,
//       issue_reported_before: initialData?.issue_reported_before || '',
//       previous_report_date: initialData?.previous_report_date || '',
//       preferred_access_time: initialData?.preferred_access_time || '',
//       access_instructions: initialData?.access_instructions || '',
//       participant_aware: initialData?.participant_aware || '',
//       photo: initialData?.photo || undefined,
//       received_by: initialData?.received_by || userDetails?.name || '',
//       date_received: initialData?.date_received || defaultDateTime,
//       action_taken: initialData?.action_taken || '',
//       assigned_to: initialData?.assigned_to || '',
//       completion_date: initialData?.completion_date || '',
//       notes: initialData?.notes || '', // Fixed syntax error
//       client_email: selectedClient?.email || '',
//       group_id: selectedProjectId || selectedClient?.projectId || '',
//       service_name_id: selectedServiceTitle || selectedClient?.serviceId || ''
//     }
//   });

//   const location_of_issue = generalForm.watch('location_of_issue');
//   const issue_reported_before = generalForm.watch('issue_reported_before');
//   const participant_aware = generalForm.watch('participant_aware');

//   const handleImageChange = (
//     e: React.ChangeEvent<HTMLInputElement>,
//     onChange: (value: File | string | undefined) => void
//   ) => {
//     const files = e.target.files;
//     if (files && files.length > 0) {
//       const file = files[0];
//       onChange(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewImage(reader.result as string);
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setPreviewImage(null);
//       onChange(undefined);
//     }
//   };

//   const handleRemoveImage = () => {
//     setPreviewImage(null);
//     generalForm.setValue('photo', undefined, { shouldValidate: true });
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const onSubmitGeneral = async (data: MaintenanceRequestFormData) => {
//     const payload: MaintenanceRequestFormData = {
//       id: data.id,
//       name: data.name,
//       role: data.role,
//       phone_number: data.phone_number,
//       email_address: data.email_address,
//       date_of_request: data.date_of_request,
//       location_of_issue: data.location_of_issue,
//       other_location: data.other_location,
//       description_of_issue: data.description_of_issue,
//       urgency_level: data.urgency_level,
//       date_issue_noticed: data.date_issue_noticed,
//       issue_reported_before: data.issue_reported_before,
//       previous_report_date: data.previous_report_date,
//       preferred_access_time: data.preferred_access_time,
//       access_instructions: data.access_instructions,
//       participant_aware: data.participant_aware,
//       photo: data.photo,
//       received_by: '',
//       date_received: '',
//       action_taken: '',
//       assigned_to: '',
//       completion_date: '',
//       notes: '',
//       client_email: data.client_email,
//       group_id: data.group_id,
//       service_name_id: data.service_name_id
//     };

//     dispatch(submitMaintenanceRequest({ formData: payload }))
//       .unwrap()
//       .then(() => {
//         generalForm.reset();
//         setPreviewImage(null);
//         if (fileInputRef.current) {
//           fileInputRef.current.value = '';
//         }
//         setTimeout(() => dispatch(clearMaintenanceRequestState()), 5000);
//       });
//   };

//   const onSubmitOffice = async (data: MaintenanceRequestFormData) => {
//     const payload: MaintenanceRequestFormData = {
//       id: maintenanceId,
//       name: data.name,
//       role: data.role,
//       phone_number: data.phone_number,
//       email_address: data.email_address,
//       date_of_request: data.date_of_request,
//       location_of_issue: data.location_of_issue,
//       other_location: data.other_location,
//       description_of_issue: data.description_of_issue,
//       urgency_level: data.urgency_level,
//       date_issue_noticed: data.date_issue_noticed,
//       issue_reported_before: data.issue_reported_before,
//       previous_report_date: data.previous_report_date,
//       preferred_access_time: data.preferred_access_time,
//       access_instructions: data.access_instructions,
//       participant_aware: data.participant_aware,
//       photo: data.photo,
//       received_by: data.received_by,
//       date_received: data.date_received,
//       action_taken: data.action_taken,
//       assigned_to: data.assigned_to,
//       completion_date: data.completion_date,
//       notes: data.notes,
//       client_email: data.client_email,
//       group_id: data.group_id,
//       service_name_id: data.service_name_id
//     };

//     dispatch(submitMaintenanceRequest({ formData: payload, initialData }))
//       .unwrap()
//       .then(() => {
//         officeForm.reset();
//         setTimeout(() => dispatch(clearMaintenanceRequestState()), 5000);
//         if (onClose) {
//           onClose();
//         }
//       });
//   };

//   const handleResetGeneral = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     generalForm.reset();
//     setPreviewImage(null);
//     generalForm.setValue('photo', undefined, { shouldValidate: true });
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//     dispatch(clearMaintenanceRequestState());
//   };

//   const handleResetOffice = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     officeForm.reset();
//     dispatch(clearMaintenanceRequestState());
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   }, []);

//   return (
//     <Box>
//       <Paper
//         elevation={isMobile ? 1 : 4}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             position: 'relative',
//             textAlign: 'center',
//             mb: isMobile ? 2 : 4,
//             px: isMobile ? 1 : 0
//           }}
//         >
//           {!isOfficeRoute && (
//             <Button
//               onClick={() => navigate(-1)}
//               variant="outlined"
//               startIcon={<FiArrowLeft />}
//               sx={{
//                 position: 'absolute',
//                 left: 0,
//                 top: 0,
//                 borderColor:
//                   theme.palette.mode === 'light'
//                     ? 'rgba(0, 0, 0, 0.23)'
//                     : 'rgba(255, 255, 255, 0.23)',
//                 color: theme.palette.text.primary,
//                 textTransform: 'none',
//                 borderRadius: 2,
//                 px: 2,
//                 py: 1,
//                 '&:hover': {
//                   borderColor: theme.palette.primary.main,
//                   backgroundColor: theme.palette.action.hover
//                 },
//                 ...(isMobile && {
//                   fontSize: '0.75rem',
//                   px: 1.5,
//                   py: 0.5
//                 })
//               }}
//             >
//               {isMobile ? 'Back' : 'Back to Forms'}
//             </Button>
//           )}

//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mb: 1,
//               flexDirection: isMobile ? 'column' : 'row',
//               mt: isMobile && !isOfficeRoute ? 4 : 0,
//               gap: isMobile ? 1 : 2
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.primary.light,
//                 p: 1.5,
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}
//             >
//               <FaFileAlt
//                 size={isMobile ? 24 : 32}
//                 style={{
//                   color: theme.palette.primary.dark
//                 }}
//               />
//             </Box>
//             <Typography
//               variant={isMobile ? 'h5' : 'h4'}
//               component="h1"
//               sx={{
//                 fontWeight: 600,
//                 lineHeight: 1.2,
//                 color: theme.palette.text.primary
//               }}
//             >
//               {isGeneralRoute
//                 ? 'Maintenance Request Form'
//                 : 'Maintenance Request - Office Use Only'}
//             </Typography>
//           </Box>

//           <Typography
//             variant={isMobile ? 'body2' : 'subtitle1'}
//             sx={{
//               color: 'text.secondary',
//               maxWidth: 600,
//               margin: '0 auto',
//               px: isMobile ? 1 : 2,
//               lineHeight: 1.4
//             }}
//           >
//             Ultra Care Services -{' '}
//             {isGeneralRoute ? 'For reporting maintenance issues' : 'For office use only'}
//           </Typography>
//         </Box>

//         {/* Success/Error Messages */}
//         {message && (
//           <Alert
//             severity="success"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearMaintenanceRequestState())}
//           >
//             {message}
//           </Alert>
//         )}
//         {error && (
//           <Alert
//             severity="error"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearMaintenanceRequestState())}
//           >
//             {error}
//           </Alert>
//         )}
//         {clientsError && (
//           <Alert severity="error" sx={{ mb: 2 }} onClose={() => setClientsError(null)}>
//             {clientsError}
//           </Alert>
//         )}
//         {isOfficeRoute && alreadyFilled && (
//           <Alert severity="warning" sx={{ mb: 2 }}>
//             This maintenance request has already been filled for Office Use Only.
//           </Alert>
//         )}

//         {isGeneralRoute && (
//           <form onSubmit={generalForm.handleSubmit(onSubmitGeneral)}>
//             {/* Participant or Staff Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Participant or Staff Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="name"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <Autocomplete
//                         size="small"
//                         options={clientsList}
//                         getOptionLabel={(option) => option.label || ''}
//                         value={clientsList.find((option) => option.label === field.value) || null}
//                         onChange={(_, newValue) => {
//                           field.onChange(newValue?.label || '');
//                           generalForm.setValue('email_address', newValue?.email || '', {
//                             shouldValidate: true
//                           });
//                         }}
//                         disabled={isClientsLoading}
//                         renderInput={(params) => (
//                           <TextField
//                             {...params}
//                             label="Participant or Staff Name"
//                             margin="normal"
//                             error={!!generalForm.formState.errors.name}
//                             helperText={generalForm.formState.errors.name?.message}
//                             InputProps={{
//                               ...params.InputProps,
//                               startAdornment: (
//                                 <InputAdornment position="start">
//                                   <FaUser size={16} />
//                                 </InputAdornment>
//                               ),
//                               endAdornment: (
//                                 <>
//                                   {isClientsLoading && (
//                                     <CircularProgress color="inherit" size={20} />
//                                   )}
//                                   {params.InputProps.endAdornment}
//                                 </>
//                               )
//                             }}
//                           />
//                         )}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="role"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Role (if staff)"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!generalForm.formState.errors.role}
//                         helperText={generalForm.formState.errors.role?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="phone_number"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Phone Number"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaPhone size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!generalForm.formState.errors.phone_number}
//                         helperText={generalForm.formState.errors.phone_number?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="email_address"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Email Address"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaEnvelope size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!generalForm.formState.errors.email_address}
//                         helperText={generalForm.formState.errors.email_address?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="date_of_request"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date of Request"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!generalForm.formState.errors.date_of_request}
//                         helperText={generalForm.formState.errors.date_of_request?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Maintenance Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaTools
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.error.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Maintenance Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Location of Issue
//                     </Typography>
//                     <Controller
//                       name="location_of_issue"
//                       control={generalForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Participant's Home"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Participant's Home
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Office"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Office</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Vehicle"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Vehicle
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Other"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Other</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {generalForm.formState.errors.location_of_issue && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {generalForm.formState.errors.location_of_issue.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 {location_of_issue === 'Other' && (
//                   <Grid item xs={12}>
//                     <Controller
//                       name="other_location"
//                       control={generalForm.control}
//                       render={({ field }) => (
//                         <TextField
//                           size="small"
//                           label="Please Specify Other Location"
//                           fullWidth
//                           margin="normal"
//                           {...field}
//                           error={!!generalForm.formState.errors.other_location}
//                           helperText={generalForm.formState.errors.other_location?.message}
//                           sx={{
//                             '& .MuiInputBase-root': {
//                               backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                             },
//                             '& .MuiInputLabel-root': {
//                               color: theme.palette.text.secondary
//                             }
//                           }}
//                         />
//                       )}
//                     />
//                   </Grid>
//                 )}
//                 <Grid item xs={12}>
//                   <Controller
//                     name="description_of_issue"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Description of Issue"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!generalForm.formState.errors.description_of_issue}
//                         helperText={generalForm.formState.errors.description_of_issue?.message}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Urgency Level
//                     </Typography>
//                     <Controller
//                       name="urgency_level"
//                       control={generalForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Emergency"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Emergency (e.g., safety hazard, no access)
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="High"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 High (requires prompt attention)
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Medium"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Medium (affects comfort or function)
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Low"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Low (minor inconvenience)
//                               </Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {generalForm.formState.errors.urgency_level && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {generalForm.formState.errors.urgency_level.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="date_issue_noticed"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date Issue Was First Noticed"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!generalForm.formState.errors.date_issue_noticed}
//                         helperText={generalForm.formState.errors.date_issue_noticed?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Has this issue been reported before?
//                     </Typography>
//                     <Controller
//                       name="issue_reported_before"
//                       control={generalForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {generalForm.formState.errors.issue_reported_before && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {generalForm.formState.errors.issue_reported_before.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 {issue_reported_before === 'Yes' && (
//                   <Grid item xs={12}>
//                     <Controller
//                       name="previous_report_date"
//                       control={generalForm.control}
//                       render={({ field }) => (
//                         <TextField
//                           size="small"
//                           label="When was it reported?"
//                           type="date"
//                           fullWidth
//                           margin="normal"
//                           InputLabelProps={{ shrink: true }}
//                           InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <FaCalendarAlt size={16} />
//                               </InputAdornment>
//                             )
//                           }}
//                           sx={{
//                             '& .MuiInputBase-root': {
//                               backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                             },
//                             '& .MuiInputLabel-root': {
//                               color: theme.palette.text.secondary
//                             }
//                           }}
//                           {...field}
//                           error={!!generalForm.formState.errors.previous_report_date}
//                           helperText={generalForm.formState.errors.previous_report_date?.message}
//                         />
//                       )}
//                     />
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>

//             {/* Access and Availability */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaCheckCircle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.success.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Access and Availability
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="preferred_access_time"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Preferred Access Time"
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!generalForm.formState.errors.preferred_access_time}
//                         helperText={generalForm.formState.errors.preferred_access_time?.message}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="access_instructions"
//                     control={generalForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Access Instructions"
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!generalForm.formState.errors.access_instructions}
//                         helperText={generalForm.formState.errors.access_instructions?.message}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Is the participant aware of this request?
//                     </Typography>
//                     <Controller
//                       name="participant_aware"
//                       control={generalForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Not applicable"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Prolonged Maintenance
//                               </Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {generalForm.formState.errors.participant_aware && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {generalForm.formState.errors.participant_aware.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="photo"
//                     control={generalForm.control}
//                     render={({ field: { onChange, onBlur, ...field } }) => (
//                       <Box>
//                         <TextField
//                           size="small"
//                           label="Upload Photo"
//                           type="file"
//                           fullWidth
//                           margin="normal"
//                           inputRef={fileInputRef}
//                           InputLabelProps={{ shrink: true }}
//                           InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <FaCamera size={16} />
//                               </InputAdornment>
//                             ),
//                             inputProps: {
//                               accept: 'image/*'
//                             }
//                           }}
//                           sx={{
//                             '& .MuiInputBase-root': {
//                               backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                             },
//                             '& .MuiInputLabel-root': {
//                               color: theme.palette.text.secondary
//                             }
//                           }}
//                           onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
//                             handleImageChange(e, onChange)
//                           }
//                           onBlur={onBlur}
//                           error={!!generalForm.formState.errors.photo}
//                           helperText={generalForm.formState.errors.photo?.message}
//                         />
//                         {previewImage && isLargeScreen && (
//                           <Box sx={{ mt: 1, textAlign: 'left' }}>
//                             <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                               Photo Preview
//                             </Typography>
//                             <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                               <Avatar
//                                 src={previewImage}
//                                 variant="rounded"
//                                 sx={{
//                                   width: isMobile ? '100%' : 150,
//                                   height: 150,
//                                   objectFit: 'contain'
//                                 }}
//                               />
//                               <IconButton
//                                 size="small"
//                                 onClick={handleRemoveImage}
//                                 sx={{
//                                   position: 'absolute',
//                                   top: -10,
//                                   right: -10,
//                                   bgcolor: theme.palette.error.main,
//                                   color: theme.palette.common.white,
//                                   '&:hover': {
//                                     bgcolor: theme.palette.error.dark
//                                   }
//                                 }}
//                               >
//                                 <CloseIcon fontSize="small" />
//                               </IconButton>
//                             </Box>
//                           </Box>
//                         )}
//                       </Box>
//                     )}
//                   />
//                 </Grid>
//                 {previewImage && !isLargeScreen && (
//                   <Grid item xs={12}>
//                     <Box
//                       sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
//                     >
//                       <Box sx={{ position: 'relative' }}>
//                         <Avatar
//                           src={previewImage}
//                           variant="rounded"
//                           sx={{
//                             width: isMobile ? '100%' : 150,
//                             height: isMobile ? 150 : 150,
//                             mt: isMobile ? 1 : 0,
//                             objectFit: 'contain'
//                           }}
//                         />
//                         <IconButton
//                           size="small"
//                           onClick={handleRemoveImage}
//                           sx={{
//                             position: 'absolute',
//                             top: -10,
//                             right: -10,
//                             bgcolor: theme.palette.error.main,
//                             color: theme.palette.common.white,
//                             '&:hover': {
//                               bgcolor: theme.palette.error.dark
//                             }
//                           }}
//                         >
//                           <CloseIcon fontSize="small" />
//                         </IconButton>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetGeneral}
//                 disabled={!generalForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Maintenance Request'}
//               </Button>
//             </Box>
//           </form>
//         )}

//         {isOfficeRoute && (
//           <form onSubmit={officeForm.handleSubmit(onSubmitOffice)}>
//             {/* Office Use Only */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaFileAlt
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Office Use Only
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="received_by"
//                     control={officeForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Received By"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!officeForm.formState.errors.received_by}
//                         helperText={officeForm.formState.errors.received_by?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="date_received"
//                     control={officeForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date Received"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!officeForm.formState.errors.date_received}
//                         helperText={officeForm.formState.errors.date_received?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="action_taken"
//                     control={officeForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Action Taken"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!officeForm.formState.errors.action_taken}
//                         helperText={officeForm.formState.errors.action_taken?.message}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="assigned_to"
//                     control={officeForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Assigned To"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!officeForm.formState.errors.assigned_to}
//                         helperText={officeForm.formState.errors.assigned_to?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="completion_date"
//                     control={officeForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Completion Date"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                         {...field}
//                         error={!!officeForm.formState.errors.completion_date}
//                         helperText={officeForm.formState.errors.completion_date?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="notes"
//                     control={officeForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Notes"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!officeForm.formState.errors.notes}
//                         helperText={officeForm.formState.errors.notes?.message}
//                         sx={{
//                           '& .MuiInputBase-root': {
//                             backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
//                           },
//                           '& .MuiInputLabel-root': {
//                             color: theme.palette.text.secondary
//                           }
//                         }}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetOffice}
//                 disabled={!officeForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading || !maintenanceId}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Office Details'}
//               </Button>
//             </Box>
//           </form>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default MaintenanceRequestForm;

import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Autocomplete,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { AppDispatch, RootState } from 'app/store';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  FaCalendarAlt,
  FaCamera,
  FaCheckCircle,
  FaEnvelope,
  FaFileAlt,
  FaPhone,
  FaTools,
  FaUndo,
  FaUser
} from 'react-icons/fa';
import { FiArrowLeft } from 'react-icons/fi';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchParticipantsList } from 'slices/HomeTilesSlices';
import {
  clearMaintenanceRequestState,
  MaintenanceRequest,
  MaintenanceRequestFormData,
  submitMaintenanceRequest
} from 'slices/NdisSlices/reportAllForms/maintenanceRequestSlice';
import * as yup from 'yup';

// Validation schemas
const generalSchema = yup
  .object({
    id: yup.string().optional(),
    name: yup.string().required('Name is required'),
    role: yup.string().optional().default(''),
    phone_number: yup.string().optional().default(''),
    email_address: yup.string().email('Invalid email address').optional().default(''),
    date_of_request: yup.string().required('Date of request is required'),
    location_of_issue: yup.string().required('Location of issue is required'),
    other_location: yup.string().when('location_of_issue', {
      is: 'Other',
      then: (schema) => schema.required('Please specify other location'),
      otherwise: (schema) => schema.optional().default('')
    }),
    description_of_issue: yup.string().required('Description of issue is required'),
    urgency_level: yup.string().required('Urgency level is required'),
    date_issue_noticed: yup.string().required('Date issue was first noticed is required'),
    issue_reported_before: yup.string().required('Please specify if issue was reported before'),
    previous_report_date: yup.string().when('issue_reported_before', {
      is: 'Yes',
      then: (schema) => schema.required('Previous report date is required'),
      otherwise: (schema) => schema.optional().default('')
    }),
    preferred_access_time: yup.string().required('Preferred access time is required'),
    access_instructions: yup.string().optional().default(''),
    participant_aware: yup.string().required('Please specify if participant is aware'),
    photo: yup.mixed<File | string>().optional().default(undefined),
    received_by: yup.string().optional().default(''),
    date_received: yup.string().optional().default(''),
    action_taken: yup.string().optional().default(''),
    assigned_to: yup.string().optional().default(''),
    completion_date: yup.string().optional().default(''),
    notes: yup.string().optional().default(''),
    client_email: yup.string().optional().default(''),
    group_id: yup.string().optional().default(''),
    service_name_id: yup.string().optional().default(''),
    resolved: yup.string().optional().default('')
  })
  .required() as yup.ObjectSchema<MaintenanceRequestFormData>;

const officeSchema = yup
  .object({
    id: yup.string().optional(),
    name: yup.string().optional().default(''),
    role: yup.string().optional().default(''),
    phone_number: yup.string().optional().default(''),
    email_address: yup.string().email('Invalid email address').optional().default(''),
    date_of_request: yup.string().optional().default(''),
    location_of_issue: yup.string().optional().default(''),
    other_location: yup.string().optional().default(''),
    description_of_issue: yup.string().optional().default(''),
    urgency_level: yup.string().optional().default(''),
    date_issue_noticed: yup.string().optional().default(''),
    issue_reported_before: yup.string().optional().default(''),
    previous_report_date: yup.string().optional().default(''),
    preferred_access_time: yup.string().optional().default(''),
    access_instructions: yup.string().optional().default(''),
    participant_aware: yup.string().optional().default(''),
    photo: yup.mixed<File | string>().optional().default(undefined),
    received_by: yup.string().optional().default(''),
    date_received: yup.string().optional().default(''),
    action_taken: yup.string().optional().default(''),
    assigned_to: yup.string().optional().default(''),
    completion_date: yup.string().optional().default(''),
    notes: yup.string().optional().default(''),
    client_email: yup.string().optional().default(''),
    group_id: yup.string().optional().default(''),
    service_name_id: yup.string().optional().default(''),
    resolved: yup
      .string()
      .oneOf(['Yes', 'No'], 'Please specify if the issue is resolved')
      .required('Please specify if the issue is resolved')
  })
  .required() as yup.ObjectSchema<MaintenanceRequestFormData>;

interface MaintenanceRequestFormProps {
  initialData?: MaintenanceRequest;
  onClose?: () => void;
}

const MaintenanceRequestForm: React.FC<MaintenanceRequestFormProps> = ({
  initialData,
  onClose
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const dispatch = useDispatch<AppDispatch>();
  const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
  const { message, loading, error } = useTypedSelector((state) => state.maintenanceRequest);
  const [previewImage, setPreviewImage] = useState<string | null>(initialData?.photo || null);
  const [alreadyFilled, setAlreadyFilled] = useState(false);
  const [isClientsLoading, setIsClientsLoading] = useState(false);
  const [clientsError, setClientsError] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = useLocation();

  // Local storage data
  const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
    label?: string;
    id?: number;
    email?: string;
    projectId?: string;
    serviceId?: string;
  };
  const loginInfo = localStorage.getItem('user-details');
  const userDetails = loginInfo ? JSON.parse(loginInfo) : null;

  // Redux state data
  const selectedProjectId = useTypedSelector(
    (state: RootState) => state.homeTilesServices.selectedProjectId
  );
  const selectedServiceTitle = useTypedSelector(
    (state: RootState) => state.serviceSelected.selectedServiceTitle
  );
  const email = userDetails?.email || '';
  const role = userDetails?.role ? [userDetails.role] : [''];

  // Participants list
  const participantsList = useTypedSelector(
    (state: RootState) => state?.homeTilesServices?.participants
  ) || { participants_list: [] };

  // Prepare clients list
  const clientsList = useMemo(
    () =>
      participantsList.participants_list?.map(
        (participant: { name: string; email: string }, index: number) => ({
          label: participant.name || `Client ${index + 1}`,
          id: index + 1,
          email: participant.email
        })
      ) || [],
    [participantsList.participants_list]
  );

  // Fetch participants
  useEffect(() => {
    if (selectedProjectId && selectedServiceTitle && email && role.length > 0) {
      setIsClientsLoading(true);
      dispatch(
        fetchParticipantsList({
          group_id: selectedProjectId || '',
          service_name_id: selectedServiceTitle || '',
          nested_component_id: pathname,
          email: email,
          roles: role,
          client_name: ''
        })
      )
        .unwrap()
        .then(() => {
          setIsClientsLoading(false);
        })
        .catch((error) => {
          setIsClientsLoading(false);
          setClientsError('Failed to load clients. Please try again later.');
        });
    } else {
      setIsClientsLoading(false);
    }
  }, [selectedProjectId]);

  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get('tab') || 'feedbacks';
  const maintenanceId = initialData?.id || undefined;

  // Determine which form section to show based on route
  const isGeneralRoute = location.pathname === '/maintenance';
  const isOfficeRoute =
    location.pathname === '/ndis-operations/corporate-services' && tabParam === 'feedbacks';
  const isFollowUpRoute = isOfficeRoute; // Assuming office route is the follow-up route

  // Check if Office Use Only or Follow-Up form is already filled
  useEffect(() => {
    if (isFollowUpRoute && initialData) {
      const isResolved = String(initialData?.resolved).toLowerCase() === 'yes';

      setAlreadyFilled(isResolved);
    } else {
      setAlreadyFilled(false);
    }
  }, [initialData, isFollowUpRoute]);

  // Current datetime as default
  const defaultDateTime = new Date().toISOString().split('T')[0];

  // Use separate useForm hooks for each route
  const generalForm = useForm<MaintenanceRequestFormData>({
    resolver: yupResolver<MaintenanceRequestFormData>(generalSchema),
    defaultValues: {
      id: initialData?.id || '',
      name: initialData?.name || selectedClient?.label || userDetails?.name || '',
      role: initialData?.role || '',
      phone_number: initialData?.phone_number || '',
      email_address:
        initialData?.email_address || selectedClient?.email || userDetails?.email || '',
      date_of_request: initialData?.date_of_request || defaultDateTime,
      location_of_issue: initialData?.location_of_issue || '',
      other_location: initialData?.other_location || '',
      description_of_issue: initialData?.description || '',
      urgency_level: initialData?.urgency_level || '',
      date_issue_noticed: initialData?.date_issue_noticed || defaultDateTime,
      issue_reported_before: initialData?.issue_reported_before || '',
      previous_report_date: initialData?.previous_report_date || '',
      preferred_access_time: initialData?.preferred_access_time || '',
      access_instructions: initialData?.access_instructions || '',
      participant_aware: initialData?.participant_aware || '',
      photo: undefined,
      received_by: '',
      date_received: '',
      action_taken: '',
      assigned_to: '',
      completion_date: '',
      notes: '',
      client_email: selectedClient?.email || '',
      group_id: selectedProjectId || selectedClient?.projectId || '',
      service_name_id: selectedServiceTitle || selectedClient?.serviceId || '',
      resolved: initialData?.resolved || ''
    }
  });

  const officeForm = useForm<MaintenanceRequestFormData>({
    resolver: yupResolver<MaintenanceRequestFormData>(officeSchema),
    defaultValues: {
      id: initialData?.id || '',
      name: initialData?.name || selectedClient?.label || userDetails?.name || '',
      role: initialData?.role || '',
      phone_number: initialData?.phone_number || '',
      email_address:
        initialData?.email_address || selectedClient?.email || userDetails?.email || '',
      date_of_request: initialData?.date_of_request || defaultDateTime,
      location_of_issue: initialData?.location_of_issue || '',
      other_location: initialData?.other_location || '',
      description_of_issue: initialData?.description || '',
      urgency_level: initialData?.urgency_level || '',
      date_issue_noticed: initialData?.date_issue_noticed || defaultDateTime,
      issue_reported_before: initialData?.issue_reported_before || '',
      previous_report_date: initialData?.previous_report_date || '',
      preferred_access_time: initialData?.preferred_access_time || '',
      access_instructions: initialData?.access_instructions || '',
      participant_aware: initialData?.participant_aware || '',
      photo: initialData?.photo || undefined,
      received_by: initialData?.received_by || userDetails?.name || '',
      date_received: initialData?.date_received || defaultDateTime,
      action_taken: initialData?.action_taken || '',
      assigned_to: initialData?.assigned_to || '',
      completion_date: initialData?.completion_date || '',
      notes: initialData?.notes || '',
      client_email: selectedClient?.email || '',
      group_id: selectedProjectId || selectedClient?.projectId || '',
      service_name_id: selectedServiceTitle || selectedClient?.serviceId || '',
      resolved: initialData?.resolved || ''
    }
  });

  const location_of_issue = generalForm.watch('location_of_issue');
  const issue_reported_before = generalForm.watch('issue_reported_before');
  const participant_aware = generalForm.watch('participant_aware');

  const handleImageChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (value: File | string | undefined) => void
  ) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      onChange(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
      onChange(undefined);
    }
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    generalForm.setValue('photo', undefined, { shouldValidate: true });
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const onSubmitGeneral = async (data: MaintenanceRequestFormData) => {
    const payload: MaintenanceRequestFormData = {
      id: data.id,
      name: data.name,
      role: data.role,
      phone_number: data.phone_number,
      email_address: data.email_address,
      date_of_request: data.date_of_request,
      location_of_issue: data.location_of_issue,
      other_location: data.other_location,
      description_of_issue: data.description_of_issue,
      urgency_level: data.urgency_level,
      date_issue_noticed: data.date_issue_noticed,
      issue_reported_before: data.issue_reported_before,
      previous_report_date: data.previous_report_date,
      preferred_access_time: data.preferred_access_time,
      access_instructions: data.access_instructions,
      participant_aware: data.participant_aware,
      photo: data.photo,
      received_by: '',
      date_received: '',
      action_taken: '',
      assigned_to: '',
      completion_date: '',
      notes: '',
      client_email: data.client_email,
      group_id: data.group_id,
      service_name_id: data.service_name_id,
      resolved: ''
    };

    dispatch(submitMaintenanceRequest({ formData: payload }))
      .unwrap()
      .then(() => {
        generalForm.reset();
        setPreviewImage(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        setTimeout(() => dispatch(clearMaintenanceRequestState()), 5000);
      });
  };

  const onSubmitOffice = async (data: MaintenanceRequestFormData) => {
    const payload: MaintenanceRequestFormData = {
      id: maintenanceId,
      name: data.name,
      role: data.role,
      phone_number: data.phone_number,
      email_address: data.email_address,
      date_of_request: data.date_of_request,
      location_of_issue: data.location_of_issue,
      other_location: data.other_location,
      description_of_issue: data.description_of_issue,
      urgency_level: data.urgency_level,
      date_issue_noticed: data.date_issue_noticed,
      issue_reported_before: data.issue_reported_before,
      previous_report_date: data.previous_report_date,
      preferred_access_time: data.preferred_access_time,
      access_instructions: data.access_instructions,
      participant_aware: data.participant_aware,
      photo: data.photo,
      received_by: data.received_by,
      date_received: data.date_received,
      action_taken: data.action_taken,
      assigned_to: data.assigned_to,
      completion_date: data.completion_date,
      notes: data.notes,
      client_email: data.client_email,
      group_id: data.group_id,
      service_name_id: data.service_name_id,
      resolved: data.resolved
    };

    dispatch(submitMaintenanceRequest({ formData: payload, initialData }))
      .unwrap()
      .then(() => {
        officeForm.reset();
        setTimeout(() => dispatch(clearMaintenanceRequestState()), 5000);
        if (onClose) {
          onClose();
        }
      });
  };

  const handleResetGeneral = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    generalForm.reset();
    setPreviewImage(null);
    generalForm.setValue('photo', undefined, { shouldValidate: true });
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    dispatch(clearMaintenanceRequestState());
  };

  const handleResetOffice = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    officeForm.reset({
      id: initialData?.id || '',
      name: initialData?.name || selectedClient?.label || userDetails?.name || '',
      role: initialData?.role || '',
      phone_number: initialData?.phone_number || '',
      email_address:
        initialData?.email_address || selectedClient?.email || userDetails?.email || '',
      date_of_request: initialData?.date_of_request || defaultDateTime,
      location_of_issue: initialData?.location_of_issue || '',
      other_location: initialData?.other_location || '',
      description_of_issue: initialData?.description || '',
      urgency_level: initialData?.urgency_level || '',
      date_issue_noticed: initialData?.date_issue_noticed || defaultDateTime,
      issue_reported_before: initialData?.issue_reported_before || '',
      previous_report_date: initialData?.previous_report_date || '',
      preferred_access_time: initialData?.preferred_access_time || '',
      access_instructions: initialData?.access_instructions || '',
      participant_aware: initialData?.participant_aware || '',
      photo: initialData?.photo || undefined,
      received_by: initialData?.received_by || userDetails?.name || '',
      date_received: initialData?.date_received || defaultDateTime,
      action_taken: initialData?.action_taken || '',
      assigned_to: initialData?.assigned_to || '',
      completion_date: initialData?.completion_date || '',
      notes: initialData?.notes || '',
      client_email: selectedClient?.email || '',
      group_id: selectedProjectId || selectedClient?.projectId || '',
      service_name_id: selectedServiceTitle || selectedClient?.serviceId || '',
      resolved: initialData?.resolved || ''
    });
    dispatch(clearMaintenanceRequestState());
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Box>
      <Paper
        elevation={isMobile ? 1 : 4}
        sx={{
          p: isMobile ? 2 : 4,
          borderRadius: 2,
          boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            mb: isMobile ? 2 : 4,
            px: isMobile ? 1 : 0
          }}
        >
          {!isOfficeRoute && (
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              startIcon={<FiArrowLeft />}
              sx={{
                position: 'absolute',
                left: 0,
                top: 0,
                borderColor:
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.23)'
                    : 'rgba(255, 255, 255, 0.23)',
                color: theme.palette.text.primary,
                textTransform: 'none',
                borderRadius: 2,
                px: 2,
                py: 1,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover
                },
                ...(isMobile && {
                  fontSize: '0.75rem',
                  px: 1.5,
                  py: 0.5
                })
              }}
            >
              {isMobile ? 'Back' : 'Back to Forms'}
            </Button>
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1,
              flexDirection: isMobile ? 'column' : 'row',
              mt: isMobile && !isOfficeRoute ? 4 : 0,
              gap: isMobile ? 1 : 2
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.primary.light,
                p: 1.5,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FaFileAlt
                size={isMobile ? 24 : 32}
                style={{
                  color: theme.palette.primary.dark
                }}
              />
            </Box>
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              component="h1"
              sx={{
                fontWeight: 600,
                lineHeight: 1.2,
                color: theme.palette.text.primary
              }}
            >
              {isGeneralRoute
                ? 'Maintenance Request Form'
                : 'Maintenance Request - Office Use Only'}
            </Typography>
          </Box>

          <Typography
            variant={isMobile ? 'body2' : 'subtitle1'}
            sx={{
              color: 'text.secondary',
              maxWidth: 600,
              margin: '0 auto',
              px: isMobile ? 1 : 2,
              lineHeight: 1.4
            }}
          >
            Ultra Care Services -{' '}
            {isGeneralRoute ? 'For reporting maintenance issues' : 'For office use only'}
          </Typography>
        </Box>

        {/* Success/Error Messages */}
        {message && (
          <Alert
            severity="success"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearMaintenanceRequestState())}
          >
            {message}
          </Alert>
        )}
        {error && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearMaintenanceRequestState())}
          >
            {error}
          </Alert>
        )}
        {clientsError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setClientsError(null)}>
            {clientsError}
          </Alert>
        )}
        {isFollowUpRoute && alreadyFilled && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This maintenance request has already been resolved or filled for Office Use Only.
          </Alert>
        )}

        {isGeneralRoute && (
          <form onSubmit={generalForm.handleSubmit(onSubmitGeneral)}>
            {/* Participant or Staff Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Participant or Staff Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <Controller
                    name="name"
                    control={generalForm.control}
                    render={({ field }) => (
                      <Autocomplete
                        size="small"
                        options={clientsList}
                        getOptionLabel={(option) => option.label || ''}
                        value={clientsList.find((option) => option.label === field.value) || null}
                        onChange={(_, newValue) => {
                          field.onChange(newValue?.label || '');
                          generalForm.setValue('email_address', newValue?.email || '', {
                            shouldValidate: true
                          });
                        }}
                        disabled={isClientsLoading}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Participant or Staff Name"
                            margin="normal"
                            error={!!generalForm.formState.errors.name}
                            helperText={generalForm.formState.errors.name?.message}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <FaUser size={16} />
                                </InputAdornment>
                              ),
                              endAdornment: (
                                <>
                                  {isClientsLoading && (
                                    <CircularProgress color="inherit" size={20} />
                                  )}
                                  {params.InputProps.endAdornment}
                                </>
                              )
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="role"
                    control={generalForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Role (if staff)"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!generalForm.formState.errors.role}
                        helperText={generalForm.formState.errors.role?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="phone_number"
                    control={generalForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Phone Number"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaPhone size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!generalForm.formState.errors.phone_number}
                        helperText={generalForm.formState.errors.phone_number?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="email_address"
                    control={generalForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Email Address"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaEnvelope size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!generalForm.formState.errors.email_address}
                        helperText={generalForm.formState.errors.email_address?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date_of_request"
                    control={generalForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date of Request"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!generalForm.formState.errors.date_of_request}
                        helperText={generalForm.formState.errors.date_of_request?.message}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Maintenance Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaTools
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.error.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Maintenance Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Location of Issue
                    </Typography>
                    <Controller
                      name="location_of_issue"
                      control={generalForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Participant's Home"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Participant's Home
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Office"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Office</Typography>
                            }
                          />
                          <FormControlLabel
                            value="Vehicle"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Vehicle
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Other"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Other</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {generalForm.formState.errors.location_of_issue && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {generalForm.formState.errors.location_of_issue.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {location_of_issue === 'Other' && (
                  <Grid item xs={12}>
                    <Controller
                      name="other_location"
                      control={generalForm.control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          label="Please Specify Other Location"
                          fullWidth
                          margin="normal"
                          {...field}
                          error={!!generalForm.formState.errors.other_location}
                          helperText={generalForm.formState.errors.other_location?.message}
                          sx={{
                            '& .MuiInputBase-root': {
                              backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                            },
                            '& .MuiInputLabel-root': {
                              color: theme.palette.text.secondary
                            }
                          }}
                        />
                      )}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Controller
                    name="description_of_issue"
                    control={generalForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Description of Issue"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!generalForm.formState.errors.description_of_issue}
                        helperText={generalForm.formState.errors.description_of_issue?.message}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Urgency Level
                    </Typography>
                    <Controller
                      name="urgency_level"
                      control={generalForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Emergency"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Emergency (e.g., safety hazard, no access)
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="High"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                High (requires prompt attention)
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Medium"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Medium (affects comfort or function)
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Low"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Low (minor inconvenience)
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {generalForm.formState.errors.urgency_level && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {generalForm.formState.errors.urgency_level.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date_issue_noticed"
                    control={generalForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date Issue Was First Noticed"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!generalForm.formState.errors.date_issue_noticed}
                        helperText={generalForm.formState.errors.date_issue_noticed?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Has this issue been reported before?
                    </Typography>
                    <Controller
                      name="issue_reported_before"
                      control={generalForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {generalForm.formState.errors.issue_reported_before && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {generalForm.formState.errors.issue_reported_before.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                {issue_reported_before === 'Yes' && (
                  <Grid item xs={12}>
                    <Controller
                      name="previous_report_date"
                      control={generalForm.control}
                      render={({ field }) => (
                        <TextField
                          size="small"
                          label="When was it reported?"
                          type="date"
                          fullWidth
                          margin="normal"
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FaCalendarAlt size={16} />
                              </InputAdornment>
                            )
                          }}
                          sx={{
                            '& .MuiInputBase-root': {
                              backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                            },
                            '& .MuiInputLabel-root': {
                              color: theme.palette.text.secondary
                            }
                          }}
                          {...field}
                          error={!!generalForm.formState.errors.previous_report_date}
                          helperText={generalForm.formState.errors.previous_report_date?.message}
                        />
                      )}
                    />
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* Access and Availability */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaCheckCircle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.success.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Access and Availability
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="preferred_access_time"
                    control={generalForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Preferred Access Time"
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!generalForm.formState.errors.preferred_access_time}
                        helperText={generalForm.formState.errors.preferred_access_time?.message}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="access_instructions"
                    control={generalForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Access Instructions"
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!generalForm.formState.errors.access_instructions}
                        helperText={generalForm.formState.errors.access_instructions?.message}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Is the participant aware of this request?
                    </Typography>
                    <Controller
                      name="participant_aware"
                      control={generalForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                          <FormControlLabel
                            value="Not applicable"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Prolonged Maintenance
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {generalForm.formState.errors.participant_aware && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {generalForm.formState.errors.participant_aware.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="photo"
                    control={generalForm.control}
                    render={({ field: { onChange, onBlur, ...field } }) => (
                      <Box>
                        <TextField
                          size="small"
                          label="Upload Photo"
                          type="file"
                          fullWidth
                          margin="normal"
                          inputRef={fileInputRef}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FaCamera size={16} />
                              </InputAdornment>
                            ),
                            inputProps: {
                              accept: 'image/*'
                            }
                          }}
                          sx={{
                            '& .MuiInputBase-root': {
                              backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                            },
                            '& .MuiInputLabel-root': {
                              color: theme.palette.text.secondary
                            }
                          }}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleImageChange(e, onChange)
                          }
                          onBlur={onBlur}
                          error={!!generalForm.formState.errors.photo}
                          helperText={generalForm.formState.errors.photo?.message}
                        />
                        {previewImage && isLargeScreen && (
                          <Box sx={{ mt: 1, textAlign: 'left' }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                              Photo Preview
                            </Typography>
                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                              <Avatar
                                src={previewImage}
                                variant="rounded"
                                sx={{
                                  width: isMobile ? '100%' : 150,
                                  height: 150,
                                  objectFit: 'contain'
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={handleRemoveImage}
                                sx={{
                                  position: 'absolute',
                                  top: -10,
                                  right: -10,
                                  bgcolor: theme.palette.error.main,
                                  color: theme.palette.common.white,
                                  '&:hover': {
                                    bgcolor: theme.palette.error.dark
                                  }
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    )}
                  />
                </Grid>
                {previewImage && !isLargeScreen && (
                  <Grid item xs={12}>
                    <Box
                      sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
                    >
                      <Box sx={{ position: 'relative' }}>
                        <Avatar
                          src={previewImage}
                          variant="rounded"
                          sx={{
                            width: isMobile ? '100%' : 150,
                            height: isMobile ? 150 : 150,
                            mt: isMobile ? 1 : 0,
                            objectFit: 'contain'
                          }}
                        />
                        <IconButton
                          size="small"
                          onClick={handleRemoveImage}
                          sx={{
                            position: 'absolute',
                            top: -10,
                            right: -10,
                            bgcolor: theme.palette.error.main,
                            color: theme.palette.common.white,
                            '&:hover': {
                              bgcolor: theme.palette.error.dark
                            }
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetGeneral}
                disabled={!generalForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Maintenance Request'}
              </Button>
            </Box>
          </form>
        )}

        {isOfficeRoute && (
          <form onSubmit={officeForm.handleSubmit(onSubmitOffice)}>
            {/* Office Use Only */}
            {isFollowUpRoute && alreadyFilled && (
              <Alert severity="warning" sx={{ mb: 2 }}>
                This maintenance request has already been resolved or filled for Office Use Only.
              </Alert>
            )}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaFileAlt
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Office Use Only
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="received_by"
                    control={officeForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Received By"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!officeForm.formState.errors.received_by}
                        helperText={officeForm.formState.errors.received_by?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date_received"
                    control={officeForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date Received"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!officeForm.formState.errors.date_received}
                        helperText={officeForm.formState.errors.date_received?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="action_taken"
                    control={officeForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Action Taken"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!officeForm.formState.errors.action_taken}
                        helperText={officeForm.formState.errors.action_taken?.message}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="assigned_to"
                    control={officeForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Assigned To"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!officeForm.formState.errors.assigned_to}
                        helperText={officeForm.formState.errors.assigned_to?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="completion_date"
                    control={officeForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Completion Date"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                        {...field}
                        error={!!officeForm.formState.errors.completion_date}
                        helperText={officeForm.formState.errors.completion_date?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Is the Issue Resolved?
                    </Typography>
                    <Controller
                      name="resolved"
                      control={officeForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {officeForm.formState.errors.resolved && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {officeForm.formState.errors.resolved.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="notes"
                    control={officeForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Notes"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!officeForm.formState.errors.notes}
                        helperText={officeForm.formState.errors.notes?.message}
                        sx={{
                          '& .MuiInputBase-root': {
                            backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#424242'
                          },
                          '& .MuiInputLabel-root': {
                            color: theme.palette.text.secondary
                          }
                        }}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetOffice}
                disabled={!officeForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading || !maintenanceId || alreadyFilled}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Office Details'}
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default MaintenanceRequestForm;
